import React, { useState } from 'react';

const C = {
 bg:'#0A1628', surface:'#0F2040', surface2:'#162A40',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 accent:'#22C55E', red:'#EF4444', amber:'#F59E0B',
 green:'#22C55E', greenBg:'rgba(34,197,94,.10)', greenBorder:'rgba(34,197,94,.25)',
};

const inr = n => '₹' + Number(n||0).toLocaleString('en-IN',{maximumFractionDigits:0});

export default function BookingSuccessModal({ booking, onClose, onPrint }) {
 const [emailSent, setEmailSent] = useState(false);
 const [sending, setSending] = useState(false);
 const [copyDone, setCopyDone] = useState(false);

 if (!booking) return null;

 const guestName = booking.guest_name || booking.company_name || 'Guest';
 const guestPhone = booking.guest_phone || '';
 const guestEmail = booking.guest_email || '';
 const code = booking.booking_code || '';
 const total = inr(booking.total_amount || 0);
 const balance = inr(booking.balance_amount || 0);
 const checkIn = booking.start_date ? new Date(booking.start_date).toLocaleDateString('en-IN',{day:'numeric',month:'long',year:'numeric'}) : '';
 const checkOut = booking.end_date ? new Date(booking.end_date).toLocaleDateString('en-IN',{day:'numeric',month:'long',year:'numeric'}) : '';

 // WhatsApp message
 const waMessage = encodeURIComponent(
` *Booking Confirmation — Botanix Nature Resort*

Dear ${guestName},

Your booking has been confirmed! Here are the details:

 *Booking ID:* ${code}
 *Check-in:* ${checkIn}
 *Check-out:* ${checkOut}
 *Guests:* ${booking.pax_count} pax
 *Total Amount:* ${total}
 *Balance Due:* ${balance}

 *Venue:* Village Damdama, Tehsil Sohna, Gurgaon-122102, Haryana

 *Payment Details:*
Botanix Resort Pvt. Ltd.
A/C: 031405004054 | IFSC: ICIC0000314
ICICI Bank, Sushant Lok, Gurgaon

For queries: +91-9211445430 | info@botanix.in

We look forward to welcoming you! 
— Team Botanix Nature Resort`
 );

 const waNumber = guestPhone.replace(/\D/g,'').replace(/^0/,'91').replace(/^(?!91)/,'91');
 const waLink = `https://wa.me/${waNumber}?text=${waMessage}`;

 // Email body
 const emailSubject = encodeURIComponent(`Booking Confirmation — ${code} | Botanix Nature Resort`);
 const emailBody = encodeURIComponent(
`Dear ${guestName},

Thank you for choosing Botanix Nature Resort!

Your booking is CONFIRMED. Here are the details:

Booking ID: ${code}
Check-in: ${checkIn}
Check-out: ${checkOut}
Guests: ${booking.pax_count} pax
Total Amount: ${total}
Balance Due: ${balance}

Venue: Botanix Nature Resort, Village Damdama, Tehsil Sohna, Gurgaon-122102, Haryana

Payment Details:
Botanix Resort Pvt. Ltd.
A/C: 031405004054 | IFSC: ICIC0000314 | ICICI Bank, Sushant Lok, Gurgaon

For queries, please contact us at:
 +91-9211445430
 info@botanix.in
 www.botanix.in

We look forward to welcoming you!

Warm regards,
Team Botanix Nature Resort`
 );

 const emailLink = `mailto:${guestEmail}?subject=${emailSubject}&body=${emailBody}`;

 const handleCopyWA = () => {
 navigator.clipboard?.writeText(decodeURIComponent(waMessage));
 setCopyDone(true);
 setTimeout(()=>setCopyDone(false), 2000);
 };

 const handleSendEmail = async () => {
 setSending(true);
 try {
 // Try to send via backend API
 await fetch('https://api.botanix.in/api/notify/email', {
 method:'POST',
 headers:{'Content-Type':'application/json'},
 body: JSON.stringify({
 to: guestEmail,
 subject: `Booking Confirmation — ${code} | Botanix Nature Resort`,
 body: decodeURIComponent(emailBody),
 }),
 });
 setEmailSent(true);
 } catch {
 // Fallback to mailto
 window.open(emailLink);
 }
 setSending(false);
 };

 return (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.85)', zIndex:3000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
 <div style={{ background:C.bg, border:`2px solid ${C.accent}`, borderRadius:20, width:'100%', maxWidth:520, overflow:'hidden' }}>

 {/* Success Header */}
 <div style={{ background:`linear-gradient(135deg,#0F2040,#162A40)`, padding:'28px 24px', textAlign:'center', borderBottom:`1px solid ${C.border}` }}>
 <div style={{ fontSize:56, marginBottom:12 }}></div>
 <div style={{ fontSize:22, fontWeight:900, color:C.accent, marginBottom:6 }}>Booking Confirmed!</div>
 <div style={{ fontSize:14, color:C.text2 }}>Ref: <strong style={{color:C.text}}>{code}</strong></div>
 </div>

 {/* Booking Summary */}
 <div style={{ padding:'20px 24px' }}>
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, padding:16, marginBottom:20 }}>
 {[
 ['Guest', guestName],
 ['Check-in', checkIn],
 ['Check-out',checkOut],
 ['Pax', booking.pax_count+' persons'],
 ['Total', total],
 ['Balance', balance],
 ].map(([k,v])=>(
 <div key={k} style={{ display:'flex', justifyContent:'space-between', padding:'5px 0', borderBottom:`1px solid ${C.border}`, fontSize:13 }}>
 <span style={{ color:C.text2 }}>{k}</span>
 <span style={{ color:C.text, fontWeight:600 }}>{v}</span>
 </div>
 ))}
 </div>

 {/* Action Buttons */}
 <div style={{ fontSize:13, fontWeight:700, color:C.text2, marginBottom:12, textTransform:'uppercase', letterSpacing:'.05em' }}>
 Share with Guest
 </div>

 <div style={{ display:'grid', gap:10 }}>

 {/* WhatsApp */}
 {guestPhone ? (
 <a href={waLink} target="_blank" rel="noreferrer"
 style={{ display:'flex', alignItems:'center', gap:12, padding:'14px 18px', background:'#25D366', borderRadius:12, textDecoration:'none', color:'#fff' }}>
 <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.135.558 4.14 1.535 5.877L.057 23.492a.75.75 0 0 0 .918.918l5.651-1.48A11.945 11.945 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.927 0-3.736-.517-5.291-1.418l-.371-.215-3.857 1.011 1.03-3.764-.228-.381A9.956 9.956 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/></svg>
 <div>
 <div style={{ fontWeight:700, fontSize:14 }}>Send via WhatsApp</div>
 <div style={{ fontSize:11, opacity:.8 }}>{guestPhone}</div>
 </div>
 <div style={{ marginLeft:'auto', fontSize:12, opacity:.8 }}>Opens WhatsApp →</div>
 </a>
 ) : (
 <div style={{ padding:'14px 18px', background:'rgba(255,255,255,.05)', borderRadius:12, border:`1px solid ${C.border}` }}>
 <button onClick={handleCopyWA}
 style={{ width:'100%', padding:'10px', background:'#25D366', border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:13, fontWeight:700 }}>
 {copyDone?' Copied!':' Copy WhatsApp Message'}
 </button>
 <div style={{ fontSize:11, color:C.text3, marginTop:6, textAlign:'center' }}>No phone number on file — paste manually</div>
 </div>
 )}

 {/* Email */}
 {guestEmail ? (
 <div style={{ display:'flex', gap:8 }}>
 <a href={emailLink}
 style={{ flex:1, display:'flex', alignItems:'center', gap:10, padding:'14px 16px', background:'rgba(37,99,168,.2)', border:'1px solid rgba(37,99,168,.4)', borderRadius:12, textDecoration:'none', color:'#fff' }}>
 <span style={{ fontSize:20 }}></span>
 <div>
 <div style={{ fontWeight:700, fontSize:13 }}>Open in Email Client</div>
 <div style={{ fontSize:11, opacity:.7 }}>{guestEmail}</div>
 </div>
 </a>
 <button onClick={handleSendEmail} disabled={sending||emailSent}
 style={{ padding:'14px 16px', background:emailSent?`${C.accent}20`:'rgba(37,99,168,.3)', border:`1px solid ${emailSent?C.accent:'rgba(37,99,168,.5)'}`, borderRadius:12, color:emailSent?C.accent:'#60A0E0', cursor:'pointer', fontSize:13, fontWeight:700, flexShrink:0 }}>
 {emailSent?' Sent!':sending?'Sending…':'Send via API'}
 </button>
 </div>
 ) : (
 <div style={{ padding:'12px 16px', background:'rgba(255,255,255,.04)', borderRadius:12, border:`1px solid ${C.border}`, fontSize:12, color:C.text3, textAlign:'center' }}>
 No email on file — add guest email to send confirmation
 </div>
 )}

 {/* Print */}
 <button onClick={()=>{ onPrint?.(booking); }}
 style={{ padding:'14px 16px', background:C.surface, border:`1px solid ${C.border2}`, borderRadius:12, color:C.text2, cursor:'pointer', fontSize:13, fontWeight:600, display:'flex', alignItems:'center', gap:10, justifyContent:'center' }}>
 Print / Download Confirmation PDF
 </button>
 </div>

 {/* Close */}
 <button onClick={onClose}
 style={{ width:'100%', marginTop:14, padding:'12px', background:'none', border:`1px solid ${C.border2}`, borderRadius:10, color:C.text2, cursor:'pointer', fontSize:13 }}>
 Close & Continue
 </button>
 </div>
 </div>
 </div>
 );
}
